import React, { useEffect, useState } from 'react';

const importAll = (r) => r.keys().map((key) => ({
    src: r(key)?.default || r(key),
    filename: key,
}));

const IconPhotoGallery = ({ onImageSelect }) => {
    const [photos, setPhotos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const images = importAll(require.context('../../images/icons', false, /\.(png|gif)$/));

        const formattedImages = images.map((image) => ({
            src: image.src,
            title: image.filename.replace(/^.*[\\/]/, '').replace(/\.[^/.]+$/, ''), // Extract file name without extension
        }));

        setPhotos(formattedImages);
    }, []);

    // Inline CSS styles
    const styles = {
        searchBox: {
            marginBottom: '10px',
            padding: '5px',
            width: 'calc(100% - 10px)',
        },
        galleryContainer: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(40px, 1fr))',
            gap: '10px',
            maxWidth: '100%',
            maxHeight: '160px',
            overflow: 'auto',
            '&::WebkitScrollbar': {
                width: '8px',
            },
            '&::WebkitScrollbarTrack': {
                background: '#f1f1f1',
            },
            '&::WebkitScrollbarThumb': {
                background: 'linear-gradient(45deg, #ff00ff, #00ffff)',
                borderRadius: '4px',
                visibility: 'visible',
            },
            '&::WebkitScrollbarThumb:hover': {
                background: 'linear-gradient(45deg, #ff00ff, #00ffff)',
            },
        },
        galleryItem: {
            width: '100%',
            height: '40px',
            overflow: 'hidden',
            cursor: 'pointer',
        },
        image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
    };

    const filteredPhotos = photos.filter(photo =>
        photo.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <input
                type="text"
                placeholder="Search images..."
                style={styles.searchBox}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onMouseDown={(e) => e.stopPropagation()}
            />
            <div style={styles.galleryContainer} onMouseDown={(e) => e.stopPropagation()}>
                {filteredPhotos.map((photo, index) => (
                    <div key={index} style={styles.galleryItem} title={photo.title} onClick={() => onImageSelect(photo.src)}>
                        <img src={photo.src} alt={photo.title} style={styles.image} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IconPhotoGallery;
